import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'lib-cdw-slide-toggle',
  templateUrl: './cdw-slide-toggle.component.html',
  styleUrls: ['./cdw-slide-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CdwSlideToggleComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CdwSlideToggleComponent implements ControlValueAccessor {
  @Input() disabled = false;
  @Input() ariaLabel = '';
  @Input() labelPosition: 'before' | 'after' = 'after';
  @Input() label = '';
  @Input() showCheckmark = false;
  @Input() trackColor = '#d4e8ff'; // Default track background color (both checked and unchecked)
  @Input() thumbColor = '#ffffff'; // Default thumb background color when checked
  @Input() thumbUncheckedColor = '#ffffff'; // Default thumb background color when unchecked
  @Input() checkmarkColor = '#34c759'; // Default checkmark icon color (Apple green)
  @Input() minusIconColor = '#ff3b30'; // Default minus icon color (Apple red)

  checked = false;

  toggle(): void {
    if (!this.disabled) {
      this.checked = !this.checked;
      this.onChange(this.checked);
      this.onTouched();
    }
  }

  writeValue(value: boolean): void {
    this.checked = !!value;
  }

  onChange = (value: boolean) => {
    // Placeholder - overridden by registerOnChange
  };

  onTouched = () => {
    // Placeholder - overridden by registerOnTouched
  };

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
